import { useMocks } from '../../shared/env';
import type { EmployeeDocumentsGateway } from './EmployeeDocumentsGateway';
import { HttpEmployeeDocumentsGateway } from './HttpEmployeeDocumentsGateway';
import { MockEmployeeDocumentsGateway } from './MockEmployeeDocumentsGateway';

export const employeeDocumentsGateway: EmployeeDocumentsGateway = useMocks ? new MockEmployeeDocumentsGateway() : new HttpEmployeeDocumentsGateway();

// Mock mode only: lets a browser test (Playwright) make the next upload fail, or make the notification email fail, the way the unit tests do. Never present
// when the real gateway is in use.
if (useMocks && typeof window !== 'undefined') {
  (window as unknown as { __epnMockEmployeeDocuments?: EmployeeDocumentsGateway }).__epnMockEmployeeDocuments = employeeDocumentsGateway;
}
export type { EmployeeDocumentsGateway } from './EmployeeDocumentsGateway';
export { checkFile, formatFileSize, ACCEPT_ATTRIBUTE, MAX_DOCUMENT_BYTES, ACCEPTED_DOCUMENT_TYPES } from './types';
export type { UploadDocumentInput } from './types';
